/**
 * Auth System Initialization
 * 
 * This file ensures auth system components are initialized in the correct order
 * to avoid circular dependency issues in production builds.
 */

import { authManager } from './auth-manager';
import { profileManager } from './profile-manager';
import { logger } from '../utils/logger';

// Initialize the connection between auth and profile managers
// This is done here to avoid circular dependencies during module initialization
export function initializeAuthSystem() {
  // When auth state changes, clear profile cache on sign out
  authManager.subscribe((session) => {
    if (!session) {
      profileManager.clearCache();
    }
  });
  
  logger.info('Auth system initialized successfully');
}

// Auto-initialize in browser environment
if (typeof window !== 'undefined') {
  // Use setTimeout to ensure all modules are loaded
  setTimeout(initializeAuthSystem, 0);
} 